<template>
  <div class="warpper_page">
    <div class="warpper_page_top">
      <div class="warpper_top disFlex">
        <h2 class="warpper_top_title mr10">业绩报表</h2>
      </div>

      <!-- tabs -->
      <PageTabs :curIdx="curIdx" @goPage="goPage" />
      <!-- <ul class="list_rpt_type">
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 3 }" @click="goPage(3, 'personRpt')">个人</li>
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 2 }" @click="goPage(2, 'groupRpt')">小组</li>
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 1 }" @click="goPage(1, 'achievementRpt')">门店</li>
      </ul> -->

      <!-- 表单 -->
      <PageForm
        ref="pageForm"
        :type="curIdx"
        :dept="dept"
        :endOpen="endOpen"
        :queryParam="queryParam"
        @handleStartOpenChange="handleStartOpenChange"
        @handleEndOpenChange="handleEndOpenChange"
        @getList="getList"
        @updateDateHandle="updateDateHandle"
        @handleExport="handleExport"
        @exportHandle="exportHandle"
        @storeChange="storeChange"

      />
      <div class="search_wrapper" v-if="false">
        <div class="search_wrapperL">
          <dd class="item_search mr20">
            <label class="item_search_lb">员工：</label>
            <div class="item_search_in">
              <a-tree-select
                v-model="queryParam.teamId"
                :tree-data="deptOptions"
                placeholder="部门"
                :replaceFields="replaceFields"
                tree-default-expand-all
                @change="handleChangeTree_achiev"
                style="width: 150px"
              >
              </a-tree-select>
              -

              <a-select
                v-model="queryParam.userId"
                @dropdownVisibleChange="handleOption_achiev($event)"
                placeholder="人员"
                style="width: 130px"
              >
                <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                  {{ item.nickName }}
                </a-select-option>
              </a-select>
            </div>
          </dd>
          <dd class="item_search">
            <label class="item_search_lb">日期：</label>
            <div class="item_search_in">
              <a-date-picker
                class="mr20"
                v-model="queryParam.startDate"
                :disabled-date="disabledStartDate"
                show-time
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                placeholder="开始时间"
                @openChange="handleStartOpenChange"
              />
              <a-date-picker
                class="mr20"
                v-model="queryParam.endDate"
                :disabled-date="disabledEndDate"
                show-time
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                placeholder="结束时间"
                :open="endOpen"
                @openChange="handleEndOpenChange"
              />
            </div>
          </dd>
          <dd class="item_search mr20">
            <a-button @click="getList">查询</a-button>
          </dd>
          <dd class="item_search">
            <a-radio-group default-value="week" @change="updateDateHandle" v-model="radioDate" button-style="solid">
              <a-radio-button value="week"> 本周 </a-radio-button>
              <a-radio-button value="month"> 本月 </a-radio-button>
              <a-radio-button value="quarter"> 本季 </a-radio-button>
              <a-radio-button value="year"> 本年 </a-radio-button>
            </a-radio-group>
          </dd>
        </div>

        <div class="search_wrapperR">
          <a-button
            type="default"
            class="btn_export"
            @click="handleExport(1)"
            v-hasPermi="['statistics:comprehensiveStatistics:performanceStatistics']"
          >
            <a-icon type="download" />业绩统计
          </a-button>

          <a-button
            type="default"
            class="btn_export"
            @click="handleExport(2)"
            v-hasPermi="['statistics:comprehensiveStatistics:performanceStatistics']"
          >
            <a-icon type="download" />业绩结算
          </a-button>

          <a-button
            type="default"
            class="btn_export"
            @click="exportHandle"
            v-hasPermi="['statistics:comprehensiveStatistics:export']"
          >
            <a-icon type="download" />导出
          </a-button>
        </div>
      </div>
    </div>
    <div class="warpper_page_body" id="warpper_page_body" v-hasPermi="['statistics:comprehensiveStatistics:list']">
      <div class="results_wrapper" id="results_wrapper">
        <a-table
          v-if="earninglist"
          :loading="loading"
          bordered
          :columns="columns"
          @change="handleChangeInTable"
          :data-source="earninglist"
          :scroll="{ y: scrollHeight }"
          :rowKey="
            (item, index) => {
              return index
            }
          "
        >
          <template slot="header" slot-scope="text, item">
            <div v-if="item.name === '总计'" class="bg_circle bgColorf0553a">
              <a-icon type="fund" style="{color:'#fff',fontSize:'14px'}" />
            </div>
            <div v-else class="bg_circle">
              <img v-if="item.avatar" class="img_avatar" :src="item.avatar" :alt="item.name" />
              <a-icon v-else class="img_avatar" type="user" />
            </div>
          </template>

          <template slot="name" slot-scope="text, item">
            <p class="name-box">{{ item.name }}</p>
          </template>
        </a-table>
        <no-data v-else></no-data>
      </div>
    </div>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import {
  earningList
  // , earningExportList
} from '@/api/achievement/earningRpt'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'
import { treeSelectMixin } from '@/mixin/treeSelect'

import PageTabs from './modules/tabs.vue'
import PageForm from './modules/pageForm.vue'
const columns = [

      // {
      //   title: '',
      //   dataIndex: 'header',
      //   key: '1',
      //   align: 'center',
      //   scopedSlots: { customRender: 'header' }
      // },
      {
        title: '',
        dataIndex: 'name',
        key: '2',
        align: 'center',
        scopedSlots: { customRender: 'name' }
      },
      {
        title: '房源新增',
        dataIndex: 'cnewHouse',
        //  sorter: true,
        key: '3',
        scopedSlots: { customRender: 'cnewHouse' }
      },
      {
        title: '房源跟进',
        dataIndex: 'cfollowHouse',
        //  sorter: true,
        key: '4',
        scopedSlots: { customRender: 'cfollowHouse' }
      },
      {
        title: '委托量',
        //  sorter: true,
        dataIndex: 'centrust',
        key: '5',
        scopedSlots: { customRender: 'centrust' }
      },
      {
        align: 'center',
        title: '钥匙',
        dataIndex: 'ckey',
        key: '6',

        scopedSlots: { customRender: 'ckey' }
      },
      {
        align: 'center',
        title: '房源被带看量',
        //  sorter: true,
        dataIndex: 'lookByHouse',
        key: '7',
        scopedSlots: { customRender: 'lookByHouse' }
      },
      {
        align: 'center',
        title: '客源新增',
        dataIndex: 'cnewCustomer',
        //  sorter: true,
        key: '8',
        scopedSlots: { customRender: 'cnewCustomer' }
      },
      {
        align: 'center',
        title: '带看量',
        dataIndex: 'lookByCustomer',
        //  sorter: true,
        key: '9',
        ellipsis: true,
        scopedSlots: { customRender: 'lookByCustomer' }
      },
      {
        title: '一带多看',
        align: 'center',
        dataIndex: 'multipleLook',
        key: '10',
        ellipsis: false,
        scopedSlots: { customRender: 'multipleLook' }
      }
]

export default {
  name: 'AchievementPersonRpt',
  components: {
    PageTabs,
    PageForm
  },
  mixins: [tableMixin, treeSelectMixin],

  data () {
    return {
      scrollHeight: 1000,
      radioDate: 'week',
      totalList: [],
      totalVo: null, // 合计数据
      earninglist: [], // 列表数据
      columns,

      loading: false,
      curIdx: 3,
      endOpen: false,
      type: '',

      dept: [],
      deptId: undefined, // 部门ID
      deptName: undefined, // 部门名称
      userList: [], // 人员列表

      endDate: undefined, //	结束日期
      listType: 3, //	列表类型（1：门店 2：小组 3：个人）
      pageNum: 1, //	当前页数
      pageSize: 1000, //	分页大小
      startDate: undefined, //	开始日期

      queryParam: {
        // 必填
        endDate: undefined, //	结束日期
        listType: 3, //	列表类型（1：门店 2：小组 3：个人）
        pageNum: 1, //	当前页数
        pageSize: 10, //	分页大小
        startDate: undefined, //	开始日期
        // 非必填
        isAsc: undefined, //	排序的方向
        isDimission: undefined, //	是否显示离职人员业绩 字典表类型：sys_yes_no
        orderByColumn: undefined, //	排序列
        storeId: undefined, //	门店ID
        teamId: undefined, //	部门ID
        userId: undefined //	员工ID
      },
      dataInfo: {},

      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      }
    }
  },
  filters: {},
  created () {
    //   this.getList();
    this.getDeptList()
    this.radioDate = 'week'
    this.updateDateHandle()
  },
  computed: {},
  watch: {},
  mounted () {
    window.addEventListener('scroll', this.menu)
    console.log(this.curIdx, '个人')
  },
  methods: {
    // handleChangeInTable(){

    // },
    loadData () {
      this.radioDate = 'week'
      this.updateDateHandle()
      if (this.curIdx === 3) {
        this.getDeptList()
      } else if (this.curIdx === 2) {
        this.getStoreList()
      } else {
         this.getDeptList()
      }
    },
    storeChange (e) {
      this.getList()
    },
    menu () {
      const FIXOBJ = document.getElementById('warpper_page_body')
      const LIMITTOP = FIXOBJ.offsetTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      const CONH = document.body.clientHeight - 390
      if (this.scroll >= LIMITTOP) {
        this.scrollHeight = CONH || 600
      }
    },
    getList () {
      this.loading = true

      earningList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.totalVo = resData.comprehensiveStatisticsVo
          this.earninglist = resData.voPage.records
          if (this.earninglist && this.earninglist.length > 0) {
            this.totalVo.name = '总计'
            this.earninglist.unshift(this.totalVo)
          }
        }
        this.loading = false
      })
    },
    queryHandle () {
      let obj = {}
      if (this.curIdx === 3) {
          obj = {
          // 必填
          endDate: this.formatDate(this.endDate), //	结束日期
          listType: this.curIdx, //	列表类型（1：门店 2：小组 3：个人）
          pageNum: this.pageNum, //	当前页数
          pageSize: this.pageSize, //	分页大小
          startDate: this.formatDate(this.startDate), //	开始日期
          // 非必填
          isAsc: this.queryParam.isAsc, //	排序的方向
          isDimission: this.queryParam.isDimission, //	是否显示离职人员业绩 字典表类型：sys_yes_no
          orderByColumn: this.queryParam.orderByColumn, //	排序列
          storeId: this.queryParam.storeId, //	门店ID
          teamId: this.queryParam.teamId, //	部门ID
          userId: this.queryParam.userId //	员工ID
        }
      } else if (this.curIdx === 2) {
          obj = {
          // 必填
          endDate: this.formatDate(this.endDate), //	结束日期
          listType: this.curIdx, //	列表类型（1：门店 2：小组 3：个人）
          pageNum: this.pageNum, //	当前页数
          pageSize: this.pageSize, //	分页大小
          startDate: this.formatDate(this.startDate), //	开始日期
          // 非必填
          isAsc: undefined, //	排序的方向
          // isDimission:undefined,//	是否显示离职人员业绩 字典表类型：sys_yes_no
          orderByColumn: undefined, //	排序列
          storeId: undefined, //	门店ID
          teamId: undefined, //	部门ID
          userId: undefined //	员工ID
        }
      } else {
          obj = {
          // 必填
          endDate: this.formatDate(this.endDate), //	结束日期
          listType: this.curIdx, //	列表类型（1：门店 2：小组 3：个人）
          pageNum: this.pageNum, //	当前页数
          pageSize: this.pageSize, //	分页大小
          startDate: this.formatDate(this.startDate), //	开始日期
          // 非必填
          isAsc: undefined, //	排序的方向
          // isDimission:undefined,//	是否显示离职人员业绩 字典表类型：sys_yes_no
          orderByColumn: undefined, //	排序列
          storeId: undefined, //	门店ID
          teamId: undefined, //	部门ID
          userId: undefined //	员工ID
        }
      }
      this.queryParam = { ...obj }

      this.getList()
    },
    goPage (val, pageName) {
      this.curIdx = 3
      this.$refs.pageForm.radioDate = 'week'
      this.loadData()
      // console.log('切换', val, this.curIdx)
      this.$router.push({ path: '/achievement/' + pageName })
    },
    updateDateHandle (val) {
      const timeType = val || this.radioDate
      this.type = timeType
      let startTime, endTime
      const now = new Date() // 当前日期
      var nowDayOfWeek = now.getDay() // 今天本周的第几天
      var nowDay = now.getDate() // 当前日
      const nowMonth = now.getMonth() // 当前月
      const nowYear = now.getFullYear() // 当前年
      const jd = Math.ceil((nowMonth + 1) / 3)
      switch (timeType) {
        case 'week':
          startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)
          endTime = new Date(nowYear, nowMonth, nowDay)
          break
        case 'month':
          startTime = new Date(nowYear, nowMonth, 1)
          endTime = new Date(nowYear, nowMonth + 1, 0)
          break
        case 'quarter':
          startTime = new Date(nowYear, (jd - 1) * 3, 1)
          endTime = new Date(nowYear, jd * 3, 0)
          break
        case 'year':
          startTime = new Date(nowYear, 0, 1)
          endTime = new Date(nowYear, 11, 31)
          break
      }
      this.startDate = startTime //	结束日期
      this.endDate = endTime //	开始日期
      this.queryHandle()
    },
    formatDate (date) {
      let d = date.getDate() // 当前日
      d = d < 10 ? '0' + d : d
      let m = date.getMonth() // 当前月
      m = m + 1
      m = m < 10 ? '0' + m : m
      const y = date.getFullYear() // 当前年
      return y + '-' + m + '-' + d
    },
    disabledStartDate (startValue) {
      const endValue = this.queryParam.endDate
      console.log(endValue)
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() >= new Date(endValue).valueOf()
    },
    disabledEndDate (endValue) {
      const startValue = this.queryParam.startDate
      if (!endValue || !startValue) {
        return false
      }
      return endValue.valueOf() <= new Date(startValue).valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
      this.getList()
    },
    handleEndOpenChange (open) {
      this.endOpen = open
      this.getList()
    },
    // 获取部门列表
    getDeptList () {
      touristApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.dept = res.data.filter((item) => {
            return item.deptLev === '2'
          })
        }
      })
    },

    // 获取部门人员列表
    chooseDept (val) {
      touristApi.getUserList({ deptId: val }).then((res) => {
        if (res.code === 200) {
          this.userList = res.rows
        }
      })
      this.getList()
    },

    userChange (e) {
      this.getList()
    },

    // 导出业绩统计-业绩结算
    handleExport (identity) {
      const parmars = {
        startDate: this.queryParam.startDate,
        endDate: this.queryParam.endDate,
        identity
      }
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        onOk () {
          that.downloadPost(
            '/comprehensiveStatistics/performanceStatistics',
            { ...parmars },
            `p_${new Date().getTime()}.xlsx`
          )
        },
        onCancel () {}
      })
    },

    /** 导出按钮操作 */
    exportHandle () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.downloadPost(
            'comprehensiveStatistics/export',
            {
              ...that.queryParam
            },
            `p_${new Date().getTime()}.xlsx`
          )
        },
        onCancel () {}
      })
    },
    // 获取门店列表
    getStoreList () {
      const storeParam = {
        deptLev: '1' // 部门等级 1门店 2小组
      }
      touristApi.getDeptList(storeParam).then((res) => {
        if (res.code === 200) {
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table-thead > tr > th{
  padding: 6px 6px
}
/deep/ .ant-table-tbody > tr > td{
  padding: 6px 6px
}
@import './report.less';
</style>
